import DashboardPage from "./DashboardPage";
import DataQualityDashboard from "../../components/Dashboard/DataQualityDashboard";

export default function DashboardsDataQuality() {
  return (
    <DashboardPage
      title="Qualidade dos dados"
      subtitle="O quanto a base que alimenta os painéis é confiável"
      info="Cada regra é checada no banco. Regras vermelhas indicam dado faltante ou inconsistente — decisões tomadas sobre elas podem estar erradas. O score é a média ponderada por severidade."
    >
      <DataQualityDashboard />
    </DashboardPage>
  );
}
